import React from 'react'
import IngredientsStock from "./IngredientsStock";
import IngredientsQuantity from "./IngredientsQuantity";
import IngredientUnits from "./IngredientsUnit";
import IngredientsPrice from "./IngredientsPrice";
import IngredientsCurrency from "./IngredientsCurrency";
import IngredientsParity from "./IngredientsParity";
import IngredientsRowTotal from "./IngredientsRowTotal";
import IngredientsDelete from "./IngredientsDelete";

const IngredientsRow = ({id, row, stocks}) => {

    return (
        <React.Fragment>
            <tr>
                <td>{Number(id) + 1}</td>
                <td colSpan={4}>
                    {
                        stocks.length ?
                            <IngredientsStock stockList={stocks} row={row} responseIndex={id}/>
                            : <p>Yükleniyor</p>
                    }
                </td>
                <td>
                    <IngredientsQuantity responseIndex={id}/>
                </td>
                <td>
                    <IngredientUnits responseIndex={id}/>
                </td>
                <td> <IngredientsPrice responseIndex={id} /> </td>
                <td> <IngredientsCurrency responseIndex={id} /> </td>
                <td> <IngredientsParity responseIndex={id} /> </td>
                <td>  <IngredientsRowTotal responseIndex={id} /> </td>
                <td> <IngredientsDelete responseIndex={id} /> </td>
            </tr>
        </React.Fragment>
    )
}
export default IngredientsRow